<template>
    <div v-if="titulo" class="cabecalho">
        {{ props.titulo }}
    </div>
</template>

<script setup>
const props = defineProps({
    titulo: {type: String, required: true}})
</script>

<style scoped>
.cabecalho{
    background-color: #517b7b;
    color: #f0f5f5;
    padding: 5px;
    border-radius: 5px;
    border: 2px solid #1e2e2e;
    font-weight: bold;
    font-size: large;
    text-align: center;
}
</style>